import { useCallback, useEffect, useRef, useState } from 'react';

const THRESHOLD = 120;

export const useScrollToTop = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToStart = useCallback(() => {
    if (containerRef.current) {
      containerRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, []);

  useEffect(() => {
    const scrollableElement = document.getElementById('scrollable-target');
    if (!scrollableElement) return;

    const handleScroll = () => {
      if (!scrollableElement || !containerRef.current) return;
      const containerRect = containerRef.current.getBoundingClientRect();
      const scrollableRect = scrollableElement.getBoundingClientRect();

      const elementTop =
        containerRect.top + scrollableElement.scrollTop - scrollableRect.top;

      setShowScrollButton(scrollableElement.scrollTop > elementTop + THRESHOLD);
    };

    handleScroll();
    scrollableElement.addEventListener('scroll', handleScroll);

    return () => {
      scrollableElement.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return { containerRef, showScrollButton, scrollToStart };
};
